import { Card, Grid } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import ChatList from './ChatList'
import ConversationMessages from './ConversationMessages'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import ContactAction from 'referencial/components/contact/actions/ContactAction'
import UserAction from 'administration/components/user/actions/UserAction'
import MessageAction from 'messages/actions/MessageAction'
import ProgressCard from 'components/card/ProgressCard'
import { orderBy, partition, startsWith } from 'lodash'
import { Chat } from '@mui/icons-material'
import Input from 'components/forms/Input'
import Tabs from 'components/Tabs'

const tabs = {
    ALL_MESSAGES: 'ALL_MESSAGES',
    UNANSWERED_MESSAGES: 'UNANSWERED_MESSAGES',
}

const MessagesApp = () => {
    const [messagesLoaded, setMessagesLoaded] = useState(false)
    const [selectedMessage, setSelectedMessage] = useState()
    const [searchedContact, setSearchedContact] = useState('')

    const {
        listOfLastMessages,
        users,
    } = useSelector(store => ({
        listOfLastMessages: store.MessagesReducer.listOfLastMessages,
        users: store.UserReducer.users,
    }), shallowEqual)
    const dispatch = useDispatch()

    useTitle(() => ([
        {
            title: i18n.messages,
            href: '/messages',
        },
    ]), [])

    useEffect(() => {
        if (!users.length) {
            dispatch(UserAction.fetchUsers())
        }
        dispatch(ContactAction.fetchContacts()).then(() =>
            dispatch(MessageAction.fetchLastMessages()).then(() => {
                setMessagesLoaded(true)
            }),
        )
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const [unansweredMessages, answeredMessages] = useMemo(() => partition(listOfLastMessages, (message) => message.login === message.updateLogin), [listOfLastMessages])

    const allMessages = useMemo(() => orderBy(
        [
            ...unansweredMessages.map(message => ({
                ...message,
                isAnswered: false,
                isSelected: selectedMessage && selectedMessage.idmessage === message.idmessage,
            })),
            ...answeredMessages.map(message => ({
                ...message,
                isAnswered: true,
                isSelected: selectedMessage && selectedMessage.idmessage === message.idmessage,
            })),
        ], 'updateDate', 'desc'), [unansweredMessages, answeredMessages, selectedMessage]).filter(message => startsWith(message.login, searchedContact))

    const onlyUnansweredMessages = useMemo(() => orderBy(
        [
            ...unansweredMessages.map(message => ({
                ...message,
                isAnswered: false,
                isSelected: selectedMessage && selectedMessage.idmessage === message.idmessage,
            })),
        ], 'updateDate', 'desc'), [unansweredMessages, selectedMessage]).filter(message => startsWith(message.login, searchedContact))

    if (!messagesLoaded) {
        return (
            <ProgressCard withMessage message={i18n.messagesWait} indeterminate round />
        )
    }

    return (
        <Grid container size={12} spacing={1} sx={{ height: 'calc(100vh - 64px)', overflowY: 'hidden', padding: '10px' }}>
            <Grid container size={3} sx={{ height: '100%' }}>
                <Card sx={{ width: '100%', height: '100%', borderRadius: '0 0 10px 10px' }}>
                    <Grid size={12} sx={{ padding: 1 }}>
                        {/* À décommenter une fois le css nettoyé
                        <Autocomplete
                            options={filteredMessages}
                            getOptionLabel={(option) => option.login}
                            onChange={(_, value) => {
                                setSelectedMessage(value)
                            }}
                            renderOption={(props, option) => (<GlobalLightMessageCard lastMessage={option} {...props}/>)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={i18n.search}
                                    sx={{
                                        '& input': {
                                            border: 'none !important',
                                            padding: 0,
                                            margin: 0,
                                            '&:focus': {
                                                boxShadow: 'none !important',
                                            },
                                        },
                                        '& .MuiOutlinedInput-root': {
                                            padding: '5px 10px 5px 10px !important',
                                        },
                                        '& .MuiInputLabel-outlined': {
                                            top: -6,
                                        },
                                    }}
                                />
                            )}
                        />
                        */}
                        <Input
                            value={searchedContact}
                            onChange={setSearchedContact}
                            title={i18n.search}
                        />
                    </Grid>
                    <Grid size={12} sx={{ height: 'calc(100% - 62px)', overflow: 'hidden' }}>
                        <Tabs
                            defaultTab={tabs.ALL_MESSAGES}
                            tabs={[
                                {
                                    constant: tabs.ALL_MESSAGES,
                                    label: i18n.allMessages,
                                },
                                {
                                    constant: tabs.UNANSWERED_MESSAGES,
                                    label: unansweredMessages.length ? `${i18n.unansweredMessages} (${unansweredMessages.length})` : i18n.unansweredMessages,
                                },
                            ]}
                        >
                            {tab => (
                                <Grid container size={12} sx={{ maxHeight: 'calc(100% - 68px)', overflowY: 'auto' }}>
                                    <ChatList messages={tab === tabs.ALL_MESSAGES ? allMessages : onlyUnansweredMessages} setSelectedMessage={setSelectedMessage} />
                                </Grid>
                            )}
                        </Tabs>
                    </Grid>
                </Card>
            </Grid>
            <Grid container size={9} justifyContent={'center'} alignItems={'center'} sx={{ height: '100%' }}>
                {selectedMessage ?
                    <ConversationMessages login={selectedMessage.login} />
                    :
                    <Card sx={{ width: '100%', height: '100%' }}>
                        <Grid container size={12} justifyContent={'center'} alignContent={'center'} sx={{ height: '100%' }}>
                            <Chat sx={{ fontSize: 70 }} />
                            <Grid size={12} sx={{ fontSize: 25, textAlign: 'center' }}>{i18n.chooseAConversation}</Grid>
                        </Grid>
                    </Card>
                }
            </Grid>
        </Grid>
    )
}

export default MessagesApp